<template>
  <div id="toolbox">
    <div class="panel-group" id="accordion" role="tablist">
      <div class="panel panel-default" v-show="this.schema.stage">
        <div class="panel-heading" role="tab">
          <h4 class="panel-title">
            <a block role="button" v-b-toggle="'collapse-calques'"> Calques </a>
          </h4>
        </div>
        <b-collapse :id="`collapse-calques`" role="tabpanel">
          <div class="panel-collapse">
            <div class="panel-body">
              <b-card no-body class="tree-container">
                <sl-vue-tree
                  v-model="nodes"
                  ref="slVueTree"
                  :allow-multiselect="true"
                  @toggle="nodeToggled"
                  @select="nodeSelected"
                >
                  <template slot="title" slot-scope="{ node }">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      v-if="node.data.isLink"
                      height="16"
                      fill="currentColor"
                      class="bi bi-link-45deg"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"
                      />
                      <path
                        d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"
                      />
                    </svg>
                    <editableUI
                      style="display: inline-block"
                      :content="node.title"
                      :editable="node.isSelected && node.data.editable"
                      @change="(name) => handleNodeTitleChange(node, name)"
                    />
                  </template>

                  <template slot="toggle" slot-scope="{ node }">
                    <span v-if="!node.isLeaf">
                      <font-awesome-icon
                        v-if="node.isExpanded"
                        :icon="['fas', 'chevron-down']"
                      />
                      <font-awesome-icon
                        v-if="!node.isExpanded"
                        :icon="['fas', 'chevron-right']"
                      />
                    </span>
                  </template>

                  <template slot="sidebar" slot-scope="{ node }">
                    <!-- <span class="visible-icon" @click="event => toggleVisibility(event, node)">
                      <font-awesome-icon v-if="!node.data || node.data.visible !== false" :icon="['fas', 'eye']" />
                      <font-awesome-icon v-if="node.data && node.data.visible === false" :icon="['fas', 'eye-slash']" />
                    </span> -->
                    <span
                      class="visible-icon delete"
                      @click="(event) => toggleDelete(event, node)"
                    >
                      <font-awesome-icon
                        v-if="!node.data.isDefault"
                        :icon="['fas', 'trash-alt']"
                      />
                    </span>
                  </template>
                </sl-vue-tree>
                <div
                  class="
                    bottom-action
                    w-100
                    d-flex
                    flex-row
                    justify-content-end
                    pr-1
                  "
                >
                  <div
                    class="mx-1 flex-grow-1"
                    v-if="
                      this.selectAction && this.selectAction.type !== 'layer'
                    "
                  >
                    <b-form-group
                      label-cols-sm="5"
                      label="Attribué à:"
                      label-align-sm="right"
                      label-for="attribution-calque"
                    >
                      <b-form-select
                        id="attribution-calque"
                        v-model="selectedLayer"
                        @change="this.moveToLayer"
                        :options="options"
                        size="sm"
                      ></b-form-select>
                    </b-form-group>
                  </div>
                  <div class="mx-2" v-b-tooltip.hover.bottom title="Avancer">
                    <span
                      class="btn-action"
                      :disabled="!selectionData.hasSelection"
                      @click="
                        () =>
                          this.moveNode(
                            this.schema.selection[
                              this.schema.selection.length - 1
                            ],
                            'up'
                          )
                      "
                    >
                      <font-awesome-icon
                        :icon="['fas', 'arrow-up']"
                        size="lg"
                      />
                    </span>
                  </div>
                  <div class="mx-2" v-b-tooltip.hover.bottom title="Reculer">
                    <span
                      class="btn-action"
                      :disabled="!selectionData.hasSelection"
                      @click="
                        () =>
                          this.moveNode(
                            this.schema.selection[
                              this.schema.selection.length - 1
                            ],
                            'down'
                          )
                      "
                    >
                      <font-awesome-icon
                        :icon="['fas', 'arrow-down']"
                        size="lg"
                      />
                    </span>
                  </div>
                  <div class="mx-2">
                    <span
                      class="btn-action"
                      v-b-tooltip.hover.bottom
                      title="Ajouter un calque"
                      @click="this.addNewLayer"
                    >
                      <font-awesome-icon
                        :icon="['fas', 'sticky-note']"
                        size="lg"
                      />
                    </span>
                  </div>
                  <!-- <button
                    @click="this.addNewLayer"
                    class="add-element">
                    <font-awesome-icon :icon="['fas', 'plus']" /> Calque
                  </button> -->
                </div>
              </b-card>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>

    <div class="panel-group" id="accordion-1" role="tablist">
      <div class="panel panel-default" v-show="this.schema.stage">
        <div class="panel-heading" role="tab">
          <h4 class="panel-title">
            <a block role="button" v-b-toggle="'collapse-espace'"> Espaces </a>
          </h4>
        </div>
        <b-collapse visible :id="`collapse-espace`" role="tabpanel">
          <div class="panel-collapse">
            <div class="panel-body">
              <div class="panel-group" role="tablist">
                <div class="panel panel-default">
                  <div
                    class="espaces"
                    v-for="(tableau, key) in tableauData"
                    :key="tableau.id"
                  >
                    <div class="panel-heading" role="tab">
                      <h6 class="panel-title">
                        <a block role="button" v-b-toggle="'collapse-' + key">
                          {{ tableau.nom }}
                        </a>
                      </h6>
                    </div>

                    <!-- collapse -->
                    <b-collapse :id="'collapse-' + key" role="tabpanel">
                      <div class="panel-collapse">
                        <div class="panel-body">
                          <div class="panel-group" role="tablist">
                            <div class="panel panel-default">
                              <div v-if="ficheData[tableau.id].length > 0">
                                <ul>
                                  <li
                                    v-for="(fiche, myKey) in ficheData[
                                      tableau.id
                                    ]"
                                    :key="myKey"
                                    v-if="fiche.denomination !== ''"
                                    :level="fiche.level"
                                    :class="{ ensemble: fiche.isEnsemble }"
                                  >
                                    <span
                                      :style="{
                                        paddingLeft: applyPadding(fiche.level),
                                      }"
                                    >
                                      <input
                                        :value="fiche.denomination"
                                        class="input-espaces"
                                        @click="selectEspaces"
                                        type="checkbox"
                                      />
                                      {{ fiche.denomination }}
                                    </span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-collapse>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import iconBase from "../icons/iconBase";
import { actions } from "./helper/models";
import iconShema from "../icons/schema";
import { mapGetters, mapActions } from "vuex";
import colorPicker from "@caohenghu/vue-colorpicker";
import inputUI from "./ui";
import { ActionType } from "./ui/actionType";
import SlVueTree from "sl-vue-tree";

export default {
  components: {
    iconBase,
    ...iconShema,
    ...inputUI,
    colorPicker,
    SlVueTree,
  },
  props: {
    schema: {
      type: Object,
      required: true,
    },
    tableauData: {
      type: Array,
    },
  },
  data() {
    return {
      actions,
      selected: actions.SELECTION,
      selectedSize: 2,
      showStrokeColorPicker: false,
      showFillColorPicker: false,
      ActionType,
      selectionData: {
        hasSelection: false,
      },
      nodes: [],
      selectedLayer: null,
      options: [],
      reducedTdata: null,
      ficheData: {},
      ficheSelected: {},
      allSelected: {},
    };
  },
  watch: {
    tableauData(newValue, oldValue) {
      this.reducedTdata = newValue.reduce((acc, curr) => {
        acc[curr.id] = curr;
        return acc;
      }, {});

      Object.keys(this.reducedTdata).forEach((key) => {
        this.ficheData[key] = this.filteredSurface(this.reducedTdata[key], key);
        this.$set(this.ficheSelected, key, []);
        this.$set(this.allSelected, key, false);
      });
    },
    currentSelection(val) {
      if (val.hasSelection) {
        this.selectedSize = val.currentStyle.strokeWidth;
        this.selectionData = val;
      }
    },
    getSelectionData(val) {
      this.selectionData = val;
      if (val.hasSelection) {
        if (val.currentType !== "layer") {
          this.selectedSize = val.currentStyle.strokeWidth;
        }
      } else {
        const slVueTree = this.$refs.slVueTree;
        slVueTree.traverse((node, nodeModel, path) => {
          this.$set(nodeModel, "isSelected", false);
        });
      }
    },
    selectAction(val) {
      const slVueTree = this.$refs.slVueTree;
      slVueTree.traverse((node, nodeModel, path) => {
        this.$set(nodeModel, "isSelected", false);
      });
      this.selectedLayer = this.schema.currentLayer;
      if (val) {
        if (val.type === "group") {
          const selected = this.schema.selection.map((el) => el._id);
          selected.push(val.node._id);
          slVueTree.traverse((node, nodeModel, path) => {
            if (selected.indexOf(nodeModel.data._id) > -1) {
              this.$set(nodeModel, "isSelected", true);
            }
          });
        } else if (val.type === "multiple") {
          const selected = this.schema.selection.map((el) => el._id);
          slVueTree.traverse((node, nodeModel, path) => {
            if (selected.indexOf(nodeModel.data._id) > -1) {
              this.$set(nodeModel, "isSelected", true);
            }
          });
        } else {
          const selected = this.schema.selection[0]._id;
          slVueTree.traverse((node, nodeModel, path) => {
            if (selected === nodeModel.data._id) {
              this.$set(nodeModel, "isSelected", true);
              return false;
            }
          });
        }
      }
    },
    getSchemaLayers: {
      handler(val) {
        this.nodes = val;
      },
      deep: true,
    },
    action(val) {
      this.selected = val;
    },
    layerList(val) {
      this.options = val.map((el) => {
        return {
          value: el,
          text: el.name(),
        };
      });
    },
  },
  computed: {
    ...mapGetters(["currentSelection", "action", "layerTree"]),
    getSchemaLayers() {
      return this.schema.schemaLayers;
    },
    getSelectionData() {
      return this.schema.selectionData;
    },
    selectAction() {
      return this.schema.selectAction;
    },
    layerList() {
      return this.schema.layerList;
    },
  },
  methods: {
    ...mapActions(["setMessage", "setAction"]),
    selectEspaces(e) {
      let target = e.target.closest("li");

      if (target.classList.contains("ensemble")) {
        let nextSibling = target.nextElementSibling;

        while (nextSibling) {
          if (
            nextSibling.getAttribute("level") === 0 ||
            nextSibling.getAttribute("level") === target.getAttribute("level")
          ) {
            return;
          }

          nextSibling.querySelector("input").checked = e.target.checked;
          nextSibling = nextSibling.nextElementSibling;
        }
      }
    },
    applyPadding(level) {
      if (level === 0) {
        return level * 2 + 5 + "px";
      }

      return level * 20 + "px";
    },
    filteredSurface(unfilteredSurfaces, onglet) {
      const res = [];
      if (!unfilteredSurfaces.columns) {
        return res;
      }
      const code = unfilteredSurfaces.columns.findIndex(
        (col) => col.key === "H0"
      );
      const denomination = unfilteredSurfaces.columns.findIndex(
        (col) => col.key === "H1"
      );

      var iteration = 0;
      unfilteredSurfaces.data.forEach((el, index) => {
        if (el !== null) {
          const isEspace =
            !unfilteredSurfaces.rows[index] ||
            unfilteredSurfaces.rows[index].type !== "ensemble";
          var isEnsemble = false;
          var level = 0;

          if (unfilteredSurfaces.rows[index]) {
            isEnsemble = unfilteredSurfaces.rows[index].type === "ensemble";
            level = unfilteredSurfaces.rows[index].level;
          }

          var elCode = el !== null && el[code] !== "" ? el[code] : "";

          if (
            (index !== 0 &&
              Array.isArray(el) &&
              el.length &&
              el[denomination] &&
              elCode !== "") ||
            isEnsemble
          ) {
            var ficheId =
              !!unfilteredSurfaces.rows &&
              !!unfilteredSurfaces.rows[index] &&
              !!unfilteredSurfaces.rows[index].fiche
                ? unfilteredSurfaces.rows[index].fiche
                : null;

            if (
              typeof unfilteredSurfaces.ficheLines[ficheId] !== "undefined" &&
              isEnsemble
            ) {
              var ligne = parseInt(unfilteredSurfaces.ficheLines[ficheId]) + 1;
            } else {
              var ligne = index;
              // console.log(ligne + ' : ' + el[denomination])
            }

            res.push({
              onglet,
              level: level,
              ligne: ligne,
              isEnsemble: isEnsemble,
              code: elCode,
              denomination: el[denomination],
              generated:
                !!unfilteredSurfaces.rows &&
                !!unfilteredSurfaces.rows[index] &&
                !!unfilteredSurfaces.rows[index].fiche,
              ficheId:
                !!unfilteredSurfaces.rows &&
                !!unfilteredSurfaces.rows[index] &&
                !!unfilteredSurfaces.rows[index].fiche
                  ? unfilteredSurfaces.rows[index].fiche
                  : null,
              templateId: unfilteredSurfaces.templateId,
            });
          }
        }
      });
      return res;
    },
    selectStrokeSize(value) {
      this.selectedSize = value;
      // EventBus.$emit('SET_STYLE', events.STROKE_SIZE, value)
      this.schema.setStyle("STROKE_SIZE", value);
    },
    actionClick(action) {
      this.setAction(action);
    },
    isActive(action) {
      return this.selected === action;
    },
    handleChangeLineType(dasharray, linecap) {
      this.schema.setStyle("LINE_TYPE", dasharray, linecap);
    },
    toRgbaString(color) {
      const { r, g, b, a } = color.rgba;
      return `rgba(${r}, ${g}, ${b}, ${a})`;
    },
    changeStrokeColor(color) {
      // EventBus.$emit('SET_STYLE', events.STROKE_COLOR, color.rgba.toRgbaString())
      this.schema.setStyle("STROKE_COLOR", this.toRgbaString(color));
    },
    changeFillColor(color) {
      // EventBus.$emit('SET_STYLE', events.SHAPE_FILL, color.rgba.toRgbaString())
      this.schema.setStyle("SHAPE_FILL", this.toRgbaString(color));
    },
    changeOpacity(value) {
      this.schema.setOpacity(value);
    },
    handleChange(type, value) {
      // EventBus.$emit('SET_TEXT_STYLE', type, value)
      this.schema.setTextStyle(type, value);
    },
    nodeSelected(nodes, event) {
      this.schema.clearSelection();
      const selectedNode = nodes.map((node) => ({
        _id: node.data._id,
        type: node.data.type,
      }))[0];
      const node = this.schema.findNode(selectedNode._id);
      this.schema.select(selectedNode.type, node);
    },
    addNewLayer() {
      try {
        this.schema.addNewLayer();
      } catch (e) {
        this.setMessage(e.message);
        // this.$toaster.error(e.message, { timeout: 2000 })
      }
    },
    handleNodeTitleChange(node, name) {
      this.schema.updateNodeName(node, name);
    },
    toggleDelete(event, node) {
      const el = this.schema.findNode(node.data._id);
      if (node.data.type === "layer") {
        this.schema.deleteNode(el, true);
      } else {
        this.schema.deleteNode(el);
      }
    },
    moveNode(node, direction) {
      // change le plan des formes
      if (node) {
        switch (direction) {
          case "up":
            this.schema.moveUp(node, node.getClassName() === "Layer");
            break;
          case "down":
            this.schema.moveDown(node, node.getClassName() === "Layer");
            break;
        }
      }
    },
    moveToLayer(layer) {
      this.schema.moveNodeTo(layer);
    },
    nodeToggled(node, e) {
      this.schema.toggleAction(node.data._id, !node.isExpanded);
    },
  },
};
</script>

<style lang="scss" scoped>
#toolbox {
  font-family: "Open sans";
  user-select: none;
  button[disabled="disabled"] {
    cursor: not-allowed;
  }
  a:hover,
  a:focus {
    text-decoration: none;
    outline: none;
  }
  .panel {
    border: none;
    box-shadow: none;
    border-radius: 0;
    margin-bottom: 15px;
  }
  .panel-action {
    margin-bottom: 15px;
  }
  .panel-heading {
    padding: 0;
    border-radius: 0;
    border: none;
    position: relative;
    z-index: 100;
  }
  .panel-title {
    margin-bottom: 0px;
    text-align: center;
  }
  .panel-title a {
    border-radius: 3px;
    background-color: #2b3085;
    color: #fff;
    display: block;
    font-size: 12px;
    line-height: 25px;
    height: 25px;
    cursor: pointer;
  }
  .panel-title a.collapsed:after {
    color: #9f9f9f;
  }
  .panel-title a.collapsed:hover:after {
    color: #fff;
  }
  .panel-body {
    font-size: 14px;
    color: #5a3245;
    line-height: 25px;
    padding: 0;
    position: relative;
    border: none;
    transition: all 0.5s ease 0s;
    margin-bottom: -3px;
    .list-group-item {
      padding-top: 3px;
      padding-bottom: 3px;
      font-size: 12px;
      font-weight: 600;
    }
  }
  .panel-body p {
    margin-bottom: 0;
  }
  .titre {
    font-size: 18px;
    font-weight: 600;
    color: #2b3085;
  }
  .accordion-menu {
    position: relative;
  }

  .shape-container {
    .shape-title {
      font-size: 14px;
      text-decoration: underline;
      margin-bottom: 3px;
      font-weight: bold;
    }
    .flex-item {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 5px;
      // background-color: rgba(0, 0, 0, 0.08);
      margin-right: 5px;
      width: 34px;
      cursor: pointer;
      border-radius: 8px;
      &:hover,
      &.active {
        background-color: #236aa3;
        color: white;
      }
    }
    .flex-item:after {
      content: " ";
      padding-top: 100%;
      display: table;
    }
  }

  .tool-container {
    .tool-title {
      font-size: 14px;
      margin-bottom: 3px;
      font-weight: bold;
      text-align: center;
    }

    .tool-color {
      width: 15px;
      height: 15px;
      border: 1px solid black;
    }
    .color-picker {
      display: flex;
      justify-content: space-around;
      box-sizing: content-box;
      .hu-color-picker {
        box-sizing: content-box;
      }
    }
    .tool-body {
      padding: 6px;
      table {
        width: 100%;
        border-collapse: separate;
        border-spacing: 5px;
        tr {
          margin-bottom: 5px;
        }
        td {
          width: 50%;
          vertical-align: bottom;
        }
      }
      font-size: 14px;
    }
  }
  .sl-vue-tree-root {
    margin-bottom: 35px;
  }
  .bottom-action {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 30px;
    background-color: #d2d3e5;
    color: #2b3085;
    .btn-action {
      font-size: 12px;
      position: relative;
      top: 2px;
      &:hover {
        cursor: pointer;
        color: #2b3085;
      }
      &[disabled="disabled"] {
        color: lightgray;
        cursor: not-allowed;
      }
    }
    #attribution-calque {
      &:focus {
        box-shadow: none;
      }
    }
    .custom-select {
      height: 22px;
      line-height: 22px;
      margin-top: 4px;
      padding-top: 0;
      padding-bottom: 0;
      font-size: 12px;
      color: #2b3085;
      border: 1px solid #2b3085;
    }
    .add-element {
      width: 100%;
      height: 100%;
      border: 1px solid #666;
      color: rgba(0, 0, 0, 0.5);
      text-align: center;
      background-color: white;
      &:hover {
        color: #fff;
        border-color: #fff;
        background-color: #2b3085;
      }
    }
  }
  .tree-container {
    flex-grow: 1;
    margin-top: -1px;
    border: 1px solid #2b3085;
    .sl-vue-tree-nodes-list {
      border: none;
      .sl-vue-tree-node-item {
        border: none;
        border-top: 1px solid #2b3085;
      }
    }
    .sl-vue-tree.sl-vue-tree-root {
      flex-grow: 1;
      overflow-x: hidden;
      overflow-y: auto;
      max-height: 300px;
    }

    .visible-icon {
      cursor: default;
      &:hover {
        cursor: pointer;
        color: red;
      }
    }
  }
}
</style>
<style lang="scss">
#toolbox {
  .tree-container {
    flex-grow: 1;
    margin-top: -3px;
    border: 1px solid #2b3085;
    .sl-vue-tree-nodes-list {
      border: none;
      .sl-vue-tree-node-item {
        border: none;
        border-top: 1px solid #2b3085;
        color: #2b3085;
        font-size: 12px;
        &:hover {
          background-color: #2b3085;
          color: #fff;
        }
      }
      .sl-vue-tree-selected > .sl-vue-tree-node-item {
        background-color: #e9eaf3;
        color: #2b3085;
      }
    }
    .sl-vue-tree.sl-vue-tree-root {
      border: none;
    }
  }
}

.espaces h6 {
  font-size: 15px;
  padding: 3px;
  background: #2b3085;
  color: #fff;
  margin-top: 5px;
  margin-bottom: 0;
}

.espaces ul {
  padding: 0;
  margin: 0;
}

.espaces ul li {
  border: 1px solid #2b3085;
  border-top: none;
  padding-left: 5px;
}

.espaces ul li span {
  font-size: 12px;
  color: #2b3085;
  font-weight: bold;
}

.espaces ul li.generated {
  background: #2b3085;
  color: #fff;
}
.espaces ul li.generated span {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/schemaFonctionnel/toolbox.vue